module.exports = __webpack_public_path__ + "img/FECREDIT.7b018362.svg";